import {
	GET_MISSTATEMENT_BY_ID,
	UPDATE_MISSTATEMENT,
	UPDATE_CURRENT_MISSTATEMENT_RELATIONS,
	ADD_PARENT_MISSTATEMENT,
	REMOVE_PARENT_MISSTATEMENT
} from '../../actions/actiontypes';
import {isApiResponseOk} from '../../util/utils';
import initialState from '../initialstate';

const isSameMisstatementId = (firstId, secondId) => String(firstId) === String(secondId);

export default function misstatementDetailsReducer(state = initialState.misstatementDetails, action) {
	const activeMisstatement = state.activeMisstatement;

	switch (action.type) {
		case GET_MISSTATEMENT_BY_ID: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					activeMisstatement: {
						...activeMisstatement,
						...action.response
					}
				};
			}
			return state;
		}
		case UPDATE_MISSTATEMENT: {
			if (isApiResponseOk(action)) {
				return {
					...state,
					activeMisstatement: {
						...activeMisstatement,
						...action.response,
						...(action.response.misstatementDescription && {description: action.response.misstatementDescription})
					}
				};
			}
			return state;
		}
		case UPDATE_CURRENT_MISSTATEMENT_RELATIONS: {
			const {misstatementId, ...relationUpdates} = action.payload || {};
			if (!activeMisstatement?.misstatementId || !isSameMisstatementId(activeMisstatement.misstatementId, misstatementId)) {
				return state;
			}

			return {
				...state,
				activeMisstatement: {
					...activeMisstatement,
					...relationUpdates
				}
			};
		}
		case ADD_PARENT_MISSTATEMENT: {
			if (!isApiResponseOk(action) || !action.actionArgs?.selectedMisstatement) {
				return state;
			}

			if (!isSameMisstatementId(activeMisstatement?.misstatementId, action.response.parentMisstatementId)) {
				return state;
			}

			const currentChildMisstatements = Array.isArray(activeMisstatement?.childMisstatements) ? activeMisstatement.childMisstatements : [];
			const alreadyRelated = currentChildMisstatements.some((child) => isSameMisstatementId(child?.misstatementId, action.response.misstatementId));
			if (alreadyRelated) {
				return state;
			}

			return {
				...state,
				activeMisstatement: {
					...activeMisstatement,
					childMisstatements: [...currentChildMisstatements, action.actionArgs.selectedMisstatement]
				}
			};
		}
		case REMOVE_PARENT_MISSTATEMENT: {
			if (!isApiResponseOk(action) || !action.actionArgs?.selectedMisstatement) {
				return state;
			}

			if (!isSameMisstatementId(activeMisstatement?.misstatementId, action.actionArgs.currentMisstatementId)) {
				return state;
			}

			const currentChildMisstatements = Array.isArray(activeMisstatement?.childMisstatements) ? activeMisstatement.childMisstatements : [];
			const updatedChildMisstatements = currentChildMisstatements.filter(
				(child) => !isSameMisstatementId(child?.misstatementId, action.actionArgs.selectedMisstatement.misstatementId)
			);

			return {
				...state,
				activeMisstatement: {
					...activeMisstatement,
					childMisstatements: updatedChildMisstatements
				}
			};
		}
		default:
			return state;
	}
}
